import { useState } from 'react';
import clsx from 'clsx';
import { ChevronDown, ChevronRight, Edit3 } from 'lucide-react';

export default function EntrySection({ title, children, defaultOpen = true, editorOnly = false, icon: Icon }) {
    const [open, setOpen] = useState(defaultOpen);

    return (
        <div className="card" style={{ padding: '0', overflow: 'hidden', marginBottom: '1rem' }}>
            <div
                style={{
                    display: 'flex',
                    alignItems: 'center',
                    gap: '0.5rem',
                    padding: '0.75rem 1rem',
                    cursor: 'pointer',
                    background: 'var(--bg-tertiary)',
                    borderBottom: open ? '1px solid var(--border)' : 'none',
                    userSelect: 'none',
                }}
                onClick={() => setOpen(!open)}
            >
                <button style={{
                    background: 'none',
                    border: 'none',
                    color: 'var(--text-secondary)',
                    cursor: 'pointer',
                    padding: 0,
                    display: 'flex',
                    alignItems: 'center',
                }}>
                    {open ? <ChevronDown size={14} /> : <ChevronRight size={14} />}
                </button>
                {Icon && <Icon size={16} color="var(--gold)" />}
                <h3 style={{ margin: 0, color: 'var(--gold)', fontSize: '0.95rem', fontWeight: 600 }}>
                    {title}
                </h3>
                {editorOnly && (
                    <span style={{
                        display: 'inline-flex',
                        alignItems: 'center',
                        gap: '0.25rem',
                        background: 'rgba(240,173,78,0.15)',
                        color: '#f0ad4e',
                        fontSize: '0.65rem',
                        fontWeight: 600,
                        padding: '0.1rem 0.4rem',
                        borderRadius: '3px',
                        textTransform: 'uppercase',
                        letterSpacing: '0.5px',
                    }}>
                        <Edit3 size={10} /> Editors only
                    </span>
                )}
            </div>
            {open && (
                <div style={{ padding: '1rem' }}>
                    {children}
                </div>
            )}
        </div>
    );
}